import { useRef } from "react";

export function useCallOnce<T = void>(callback: () => T) {
  const called = useRef(false);
  return () => {
    if (called.current === false) {
      called.current = true;
      callback();
    }
  };
}
